
































































import Vue from 'vue';
import { Prop, Component, Watch } from 'vue-property-decorator';

@Component
export default class CardForm extends Vue {
  static provides: string[] = [
    'prop:title',
    'prop:editBtn',
    'prop:cancelBtn',
    'prop:submitBtn',
    'prop:errorMessage',
    'prop:successMesssage',
    'prop:settings',
    'method:getError',
    'method:resetErrors'
  ];

  @Prop({ default: 'Title' }) 
  title!: string;

  @Prop({ default: 'edit' }) 
  editBtn!: string;

  @Prop({ default: 'Cancel' }) 
  cancelBtn!: string;

  @Prop({ default: 'Submit' }) 
  submitBtn!: string;

  @Prop({ default: 'Error' }) 
  errorMessage!: string;

  @Prop({ default: 'Success' }) 
  successMessage!: string;

  @Prop() 
  overlayMessage!: any;

  @Prop() 
  overlayError!: any;

  @Prop(Boolean) 
  toasts!: boolean;

  @Prop(Boolean) 
  editable!: boolean;

  @Prop(Boolean) 
  hideTitle!: boolean;

  @Prop(Boolean) 
  topActions!: boolean;

  @Prop(Boolean) 
  bottomActions!: boolean;

  @Prop(Object) 
  target!: any;

  getDefaultParent() {
    return { 
      state: {}, 
      $nextTick: () => {} 
    };
  }

  parent: any = this.getDefaultParent();

  default_slot: string = 'default';

  get isParentDisabled() {
    return this.target === null;
  }


  mounted() {
    this.parent = this.isParentDisabled
      ? this.getDefaultParent()
      : this.target || this.$parent || this.parent;
  }

  listener() {
  }

  updateState() {
    if(this.isParentDisabled) {
      return; 
    }

    const children = this.$slots[ this.default_slot || 'default'];
    const walk = (node: any) => {
      if(!node) { 
        return; 
      }

      if (Array.isArray(node)) {
        node.forEach(walk);
      } else {
          (this.parent || this).$nextTick(() => {
          if (
            node.componentInstance &&
            node.componentInstance.$_modelEvent === 'input'
          ) {
            if (this.parent.edit) {
              node.componentInstance.errorMessages = this.parent.getError(
                node.componentInstance.$attrs.name
              );
            } else { 
              node.componentInstance.errorMessages = null; 
            }

            if(node.componentInstance.errorMessages) {
              node.child.$el.onmousedown = () => this.parent.resetError(node.componentInstance.$attrs.name);
              node.child.$el.onfocus = () => this.parent.resetError(node.componentInstance.$attrs.name);
            }

            node.componentInstance.disabled = !this.parent.edit;
          }
          
          if(node.children) { 
            walk(node.children); 
          }
        });
      }
    };
    walk(children);
  }

  @Watch('parent.edit')
  editWatcher(val: any) {
    if(!val && this.parent.onReset) { 
      this.parent.onReset(); 
    }

    if(this.parent.resetErrors) { 
      this.parent.resetErrors(); 
    }

    this.updateState();
  }

  @Watch('parent.state')
  stateWatcher() {
    this.updateState();
  }
}
